import Preferences from './preferences.js';
import Toast from './toast.js';

export default class Inspiration {
	private static messages: string[] = [
		"Focus on the process, not the profit.",
		"Trading is a marathon, not a sprint. Be patient.",
		"Protect your capital. It's your only tool.",
		"A missed trade is better than a forced loss.",
		"Discipline is the only edge you really have.",
		"The market will always be there tomorrow. Don't force it today.",
		"Your best trade is often the one you didn't take.",
		"Stick to your rules. The results will follow.",
		"Every loss is a lesson. What did this one teach you?",
		"Success in trading comes from managing risk, not predicting the future.",
		"Don't let a winning trade make you overconfident.",
		"Don't let a losing trade make you fearful.",
		"Think in probabilities, not certainties.",
		"Are you following your plan right now?",
		"Take a deep breath. Clear your mind before the next setup.",
		"If you're feeling emotional, step away from the screens.",
		"Your goal is to be a professional, not a gambler.",
		"Trading is simple, but it's not easy. Stay focused.",
		"Be proud of following your rules, regardless of the outcome.",
		"Consistency is born from discipline."
	];

	private static timer: any = null;

	public static init() {
		if (Inspiration.timer) return;
		
		// Set first message after 1 minute
		Inspiration.timer = setTimeout(() => {
			if (Inspiration.timer === 'stopped') { return; }
			Inspiration.show();
			Inspiration.scheduleNext();
		}, 60 * 1000);
	}

	private static scheduleNext() {
		if (Inspiration.timer === 'stopped') { return; }
		// Random interval between 1 and 7 minutes (in milliseconds)
		const delay = Math.floor(Math.random() * (7 - 1 + 1) + 1) * 60 * 1000;
		
		Inspiration.timer = setTimeout(() => {
			if (Inspiration.timer === 'stopped') { return; }
			Inspiration.show();
			Inspiration.scheduleNext();
		}, delay);
	}

	/** Stop the pop-ups for this page view (the preference covers future pages). */
	public static stop() {
		if (Inspiration.timer) { clearTimeout(Inspiration.timer); }
		Inspiration.timer = 'stopped';
	}

	private static async show() {
		// Users can switch these off (Profile → Preferences, or the toast's own button).
		const prefs = await Preferences.get();
		if (prefs.showInspiration === false || Inspiration.timer === 'stopped') { return; }

		const randomIndex = Math.floor(Math.random() * Inspiration.messages.length);
		const message = Inspiration.messages[randomIndex];
		
		// Show toast for 30 seconds (30000ms)
		const action = window.user != null
			? {
				label: "Don't show these",
				onClick: async () => {
					Inspiration.stop();
					const saved = await Preferences.save({ showInspiration: false });
					Toast.show(saved ? 'Motivational pop-ups turned off. Turn them back on in your Profile.' : 'Could not save that setting — please try again.', saved ? 'success' : 'error', 5000);
				}
			}
			: undefined;
		Toast.show(message, 'info', 30000, action);
	}
}
